export const BIRTHDATE_TOO_RECENT = 'Das Geburtsdatum muss mindestens 30 Tage in der Vergangenheit liegen.';

export function latestDataCheckBirthdate(now = new Date()) {
  // Use the same calendar day as the API, including around midnight and DST.
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const value = type => Number(parts.find(part => part.type === type).value);
  const date = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
  date.setUTCDate(date.getUTCDate() - 30);
  return date.toISOString().slice(0, 10);
}

export function dataCheckBirthdateError(value, now = new Date()) {
  if (!value) return ''; // The field remains optional.
  const parsed = new Date(`${value}T12:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || Number.isNaN(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== value) {
    return 'Geburtsdatum ist ungültig.';
  }
  return value > latestDataCheckBirthdate(now) ? BIRTHDATE_TOO_RECENT : '';
}
